export const DEFAULT_OPTIONS = {
    momentumLimitTime: 300,
    momentumLimitDistance: 15,
    noBounce: 2500,
    weekBounce: 800,
    strongBounce: 400
}

export function elasticRollingDistance(current, start, duration) {
    // 惯性滑动加速度
    const deceleration = 0.003
    const distance = current - start
    const speed = 2 * Math.abs(distance) / duration
    const destination = current + speed / deceleration * (distance < 0 ? -1 : 1)
    return destination
}

/**
 *  current  结束位置
 *  start    开始位置
 *  time     时长
 *  lowerMargin 滚动区域下限值（一般为0）
 *  upperMargin 滚动区域上限值 （一般为maxScroll）
 *  wrapperSize 当滚动超过边缘的时候会有一小段回弹动画 (bounce)
 *
 *  distance 距离
 *  speed    速度
 *  deceleration 减速度(系数) 0.003
 *  destination  目的地
 */
export function momentum(current, start, duration, lowerMargin, upperMargin, wrapperSize) {
    let type = 'noBounce'
    // 回弹阻力
    const bounceRate = 10
    // 强弱回弹的分割值
    const bounceThreshold = 300
    // 回弹的最大限度
    const maxOverflowY = wrapperSize / 6
    let overflowY

    let destination = elasticRollingDistance(current, start, duration)

    if (destination < lowerMargin) {
        overflowY = lowerMargin - destination
        type = overflowY > bounceThreshold ? 'strongBounce' : 'weekBounce'
        destination = Math.max(lowerMargin - maxOverflowY, lowerMargin - overflowY / bounceRate)
    } else if (destination > upperMargin) {
        overflowY = destination - upperMargin
        type = overflowY > bounceThreshold ? 'strongBounce' : 'weekBounce'
        destination = Math.min(upperMargin + maxOverflowY, upperMargin + overflowY / bounceRate)
    }

    return {
        destination,
        duration: DEFAULT_OPTIONS[type],
        bezier: bezierMap[type]
    }
}

// 前者精确度远比后者高。后者只能精确到ms。
export function getNow() {
    return +new Date()
}

export const bezierMap = {
    noBounce: 'cubic-bezier(.17, .89, .45, 1)',
    weekBounce: 'cubic-bezier(.25, .46, .45, .94)',
    strongBounce: 'cubic-bezier(.25, .46, .45, .94)'
}

// 获取this.scroller当前(x,y)的位置
export function getComputedPosition(scroller) {
    // 设置为null，获取到全部的属性值
    let matrix = window.getComputedStyle(scroller, null).getPropertyValue('transform')
    // transform: "matrix(1, 0, 0, 1, 0, 0)"
    matrix = matrix.split(')')[0].split(', ')
    const x = +(matrix[12] || matrix[4])
    const y = +(matrix[13] || matrix[5])

    return {
        x,
        y
    }
}
